import styled from 'styled-components';
import { MobileScreen } from '../../../styles/ConstantMediaQuery';

// TODO(PEDRO) na refatoração, mover esse arquivo para uma pasta de estilos compartilhados
export const Wrapper = styled.div`
    background: ${({ backgroundColor }) => backgroundColor};
    height: 450px;
    
    ${({ styles }) => styles && { ...styles }};
`;

export const Image = styled.img`
    position: absolute;
    ${({ styles }) => styles && { ...styles }};

    @media ${MobileScreen} {
        display: none;
    }
`;
